import { render, staticRenderFns } from "./CargaHoraria.vue?vue&type=template&id=0d19a250&scoped=true"
import script from "./CargaHoraria.vue?vue&type=script&lang=js"
export * from "./CargaHoraria.vue?vue&type=script&lang=js"
import style0 from "./CargaHoraria.vue?vue&type=style&index=0&id=0d19a250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d19a250",
  null
  
)

export default component.exports